<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
<!--              <el-form-item label="凭证ID">-->
<!--                  <el-input  v-model="queryForm.voucherId"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="当前期数">
                  <el-input  v-model="queryForm.currentPeriod"></el-input>
              </el-form-item>
              <el-form-item label="本期补贴金额">
                  <el-input  v-model="queryForm.currentMoney"></el-input>
              </el-form-item>
              <el-form-item label="递增比率">
                  <el-input  v-model="queryForm.incrementalRate"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopIncomeVoucherRecordList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addShopIncomeVoucherRecord"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editShopIncomeVoucherRecord(null)"-->
<!--        >修改</el-button>-->
<!--        <el-button-->
<!--          type="danger"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-delete"-->
<!--          :disabled="multipleSelection.length <= 0"-->
<!--          @click="deleteShopIncomeVoucherRecord(null)"-->
<!--        >删除</el-button>-->
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportShopIncomeVoucherRecordList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshShopIncomeVoucherRecordList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopIncomeVoucherRecordList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="voucherId"-->
<!--        label="凭证ID"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="currentPeriod"
        label="当前期数"
        min-width="100"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="currentMoney"
        label="本期补贴金额"
        min-width="140"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="incrementalRate"
        label="递增比率"
        min-width="100"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        min-width="100"
      > </el-table-column>
<!--      <el-table-column-->
<!--        fixed="right"-->
<!--        align="center"-->
<!--        label="操作"-->
<!--        width="300"-->
<!--      >-->
<!--        <template slot-scope="scop">-->
<!--          <div class="operation">-->
<!--            <div @click="checkShopIncomeVoucherRecord(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Eye24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">查看</span>-->
<!--            </div>-->
<!--            <div @click="editShopIncomeVoucherRecord(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
<!--            <div @click="deleteShopIncomeVoucherRecord(scop.row.id)">-->
<!--              <Icon size="16" style="color: red">-->
<!--                <Delete24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label" style="color: red">删除</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopIncomeVoucherRecordStates[shopIncomeVoucherRecordState]"
      :visible.sync="showDialog"
      width="60%"
      :append-to-body="true"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopIncomeVoucherRecord"
          ref="shopIncomeVoucherRecordForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
<!--          <el-form-item-->
<!--            label="凭证ID"-->
<!--            prop="voucherId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopIncomeVoucherRecord.voucherId"-->
<!--              :disabled="shopIncomeVoucherRecordState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="当前期数"
            prop="currentPeriod"
          >
            <el-input
              size="small"
              v-model="shopIncomeVoucherRecord.currentPeriod"
              :disabled="shopIncomeVoucherRecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="本期补贴金额"
            prop="currentMoney"
          >
            <el-input
              size="small"
              v-model="shopIncomeVoucherRecord.currentMoney"
              :disabled="shopIncomeVoucherRecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="递增比率"
            prop="incrementalRate"
          >
            <el-input
              size="small"
              v-model="shopIncomeVoucherRecord.incrementalRate"
              :disabled="shopIncomeVoucherRecordState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopIncomeVoucherRecordState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopIncomeVoucherRecordList();
                    this.getShopIncomeVoucherRecordList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopIncomeVoucherRecordList();
                    this.getShopIncomeVoucherRecordList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     voucherId: '', //凭证ID
                     currentPeriod: '', //当前期数
                     currentMoney: '', //本期补贴金额
                     incrementalRate: '', //递增比率
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopIncomeVoucherRecordState: 'add',
                shopIncomeVoucherRecordStates: {
                    add: '新建补贴记录',
                    check: '查看补贴记录',
                    edit: '修改补贴记录'
                },

                multipleSelection: [],
                shopIncomeVoucherRecordList: [],
                shopIncomeVoucherRecord: {
                    id: '', //
                    voucherId: '', //凭证ID
                    currentPeriod: '', //当前期数
                    currentMoney: '', //本期补贴金额
                    incrementalRate: '', //递增比率
                },
                btnLoading: false,

                rules: {
                    voucherId: [{ required: true, message: '凭证ID不能为空', trigger: 'blur' }],
                    currentPeriod: [{ required: true, message: '当前期数不能为空', trigger: 'blur' }],
                    currentMoney: [{ required: true, message: '本期补贴金额不能为空', trigger: 'blur' }],
                    incrementalRate: [{ required: true, message: '递增比率不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            // this.getShopIncomeVoucherRecordList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            init(id){
                this.currentPage = 1;
                this.queryForm.voucherId = id;
                this.shopIncomeVoucherRecord.voucherId = id;
                this.getShopIncomeVoucherRecordList();
            },
            resetShopIncomeVoucherRecordList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopIncomeVoucherRecordList = [];
            },
            resetDialog() {
                this.shopIncomeVoucherRecordState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      voucherId: this.queryForm.voucherId, //凭证ID
                      currentPeriod: '', //当前期数
                      currentMoney: '', //本期补贴金额
                      incrementalRate: '', //递增比率
                };
                this.getShopIncomeVoucherRecordList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopIncomeVoucherRecord = {
                      id: '', //
                      voucherId: this.shopIncomeVoucherRecord.voucherId, //凭证ID
                      currentPeriod: '', //当前期数
                      currentMoney: '', //本期补贴金额
                      incrementalRate: '', //递增比率
                };
            },
            submitForm() {
                if (this.shopIncomeVoucherRecordState == 'add') {
                    this.$refs.shopIncomeVoucherRecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/biz/incomevoucherrecord/add`,{ ...this.shopIncomeVoucherRecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopIncomeVoucherRecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopIncomeVoucherRecordState == 'edit') {
                    this.$refs.shopIncomeVoucherRecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/biz/incomevoucherrecord/edit`,{ ...this.shopIncomeVoucherRecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopIncomeVoucherRecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopIncomeVoucherRecord() {
                this.showDialog = true;
                this.shopIncomeVoucherRecordState = 'add';
            },
            checkShopIncomeVoucherRecord(shopIncomeVoucherRecordId) {
                console.log(shopIncomeVoucherRecordId);
                this.currentShopIncomeVoucherRecordId = shopIncomeVoucherRecordId;

                this.getShopIncomeVoucherRecordById();
                this.showDialog = true;
                this.shopIncomeVoucherRecordState = 'check';
            },
            editShopIncomeVoucherRecord(shopIncomeVoucherRecordId) {
                console.log('shopIncomeVoucherRecord', shopIncomeVoucherRecordId);
                if (shopIncomeVoucherRecordId) {
                    this.currentShopIncomeVoucherRecordId = shopIncomeVoucherRecordId;
                    this.getShopIncomeVoucherRecordById();
                } else {
                    this.shopIncomeVoucherRecord = { ...this.shopIncomeVoucherRecord, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopIncomeVoucherRecordState = 'edit';
            },
            deleteShopIncomeVoucherRecord(shopIncomeVoucherRecordId) {
                let ids = '';
                if (shopIncomeVoucherRecordId) {
                    ids = shopIncomeVoucherRecordId;
                } else {
                    ids = this.multipleSelection.map((shopIncomeVoucherRecord) => shopIncomeVoucherRecord.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/biz/incomevoucherrecord/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopIncomeVoucherRecordList();
                                this.getShopIncomeVoucherRecordList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopIncomeVoucherRecordList() {
                this.resetShopIncomeVoucherRecordList();
                this.getShopIncomeVoucherRecordList();
            },
            getShopIncomeVoucherRecordList(query = {}) {
                this.loading = true;
                get(`/biz/incomevoucherrecord/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopIncomeVoucherRecordList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopIncomeVoucherRecordById() {
                get(`/biz/incomevoucherrecord/get`,{ id: this.currentShopIncomeVoucherRecordId }).then((res) =>{
                    if(res.success){
                      this.shopIncomeVoucherRecord = { ...this.shopIncomeVoucherRecord, ...res.shopIncomeVoucherRecord };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopIncomeVoucherRecordList() {
                //this.btnLoading = true;
                exprotExcel(`/biz/incomevoucherrecord/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/biz/incomevoucherrecord/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/biz/incomevoucherrecord/importData`,formData);
              this.refreshShopIncomeVoucherRecordList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopIncomeVoucherRecordList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopIncomeVoucherRecordList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>